import { useState } from "react";
import { Button, Divider, Menu, MenuItem, MenuList } from "@mui/material";
import { ArrowDropDown as MenuIcon } from "@mui/icons-material";
import { useLogout } from "@/hooks/useLogout";

type ProfileMenuProps = {
  username: string;
};

/**
 * 전체 메뉴
 *
 * @param props
 * @returns
 */
export const ProfileMenu = (props: ProfileMenuProps) => {
  const { username } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const { logout } = useLogout();

  const handleLogoutClick = () => {
    logout();
  };

  return (
    <div>
      <Button
        variant={"text"}
        endIcon={<MenuIcon />}
        sx={(theme) => ({ color: theme.palette.common.black })}
        onClick={handleMenuClick}
      >
        {username}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuList dense sx={{ width: 160, py: 0 }}>
          <Divider />
          <MenuItem onClick={handleLogoutClick}>로그아웃</MenuItem>
        </MenuList>
      </Menu>
    </div>
  );
};
